import React from 'react';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import {
  BEACON_CHART_SPACING,
  BEACON_PRO_PAGE_MARGIN_BOTTOM
} from 'src/components/Layout/Beacon/BeaconProLayoutConsts';
import { PercentTotalTrafficSplineChart } from '../../Total/PercentTotalTrafficSplineChart';
import { PaidSearchTopicsKeyMetricCards } from '../Topics/PaidSearchTopicsKeyMetricCards';
import { PaidSearchTopicsMultiMetricSplineChart } from '../Topics/PaidSearchTopicsMultiMetricSplineChart';
import { PaidSearchTopicsDoubleOptionBarChart } from '../Topics/PaidSearchTopicsDoubleOptionBarChart';
import { PaidSearchTopicsGrid } from '../Topics/PaidSearchTopicsGrid';
import { ChartContextProvider } from 'src/utils/chartContext/ChartContextGroupContext';
import { CHART_CONTEXT_GROUPS, CHART_NAMES } from 'src/utils/chartContext/chartContextRegistry';

/**
 * Paid search tab for topics or topic groups
 */
export function TopicOrTopicGroupPage() {
  return (
    <Flex flexDirection="column" gap={BEACON_CHART_SPACING} marginBottom={BEACON_PRO_PAGE_MARGIN_BOTTOM}>
      <PaidSearchTopicsKeyMetricCards />
      <ChartContextProvider
        group={CHART_CONTEXT_GROUPS.BEACON_PAID_SEARCH_TOPICS_BAR.name}
        chartName={CHART_NAMES.BEACON_PAID_SEARCH_TOPICS_BAR_COLUMN}
      >
        <PaidSearchTopicsDoubleOptionBarChart />
      </ChartContextProvider>
      <ChartContextProvider
        group={CHART_CONTEXT_GROUPS.BEACON_PAID_SEARCH_TOPICS_TREND.name}
        chartName={CHART_NAMES.BEACON_PAID_SEARCH_TOPICS_TREND_SPLINE}
      >
        <PaidSearchTopicsMultiMetricSplineChart />
      </ChartContextProvider>
      <ChartContextProvider
        group={CHART_CONTEXT_GROUPS.BEACON_PAID_SEARCH_TOPICS_PERCENT.name}
        chartName={CHART_NAMES.BEACON_PAID_SEARCH_TOPICS_PERCENT_SPLINE}
      >
        <PercentTotalTrafficSplineChart trafficType="paidTraffic" />
      </ChartContextProvider>
      <PaidSearchTopicsGrid />
    </Flex>
  );
}
